module.exports = __webpack_public_path__ + "img/NotesScreenRe.ac6368a2.svg";